module.exports = __webpack_public_path__ + "static/media/Cam_03.34a01ec5.jpg";